import { Section } from "Components/Section";
import React, { useContext } from "react";
import { DashboardLink } from "Views/DashboardLink";
import { UserContext } from "Views/UserProvider";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function LossPayeeAlreadyAddedPage() {
  const { user } = useContext(UserContext);
  return (
    <LcpAppPageWrapper isWide documentTitle={"Loss Payee Already Added"}>
      <Section title={"Loss Payee Already Added"}>
        A Loss Payee has already been added to this policy. Please contact us
        using the information below if you have any questions.
        {user && <DashboardLink />}
      </Section>
    </LcpAppPageWrapper>
  );
}
